import { API_NEW } from 'src/API';
import { IssuedDataType } from './Types';

/** АПИ для обращений к сервису */
class API extends API_NEW {
	/**
	 * Поиск данных кем выдан паспорт
	 * @param term Строка поиска
	 * @param limit Лимит возвращаемых ответов ( не более 10 )
	 * @returns Промис с результатом ответа сервера
	 */
	static searchData = (term: string, limit = 10) => {
		return this.onRequest<IssuedDataType[]>({
			url: `${window.host}/v1/issuers?query=${term}&limit=${limit}`,
			withCredentials: true,
		});
	};
}

export default API;
